import { SxProps, Theme } from "@mui/material";

export const getAddTaskButtonSx = (
  theme: Theme,
  isMobile: boolean,
): SxProps<Theme> => ({
  width: "100%",
  background: "transparent",
  color: theme.nawy.colors.semantic.text.accent,
  ...theme.nawy.typography.english.variants.body.md.semibold,
  boxShadow: "none",
  textAlign: "left",
  justifyContent: "flex-start",
  margin: 0,
  marginTop: isMobile ? "5px !important" : "0 !important",
  padding: 0,
  "&:hover": {
    background: "transparent",
    color: theme.nawy.colors.semantic.text.accent,
    boxShadow: "none",
  },
  "&:active": {
    background: "transparent",
    color: theme.nawy.colors.semantic.text.accent,
    boxShadow: "none",
  },
  "&:focus": {
    background: "transparent",
    color: theme.nawy.colors.semantic.text.accent,
    boxShadow: "none",
  },
  "&:focus-visible": {
    background: "transparent",
    color: theme.nawy.colors.semantic.text.accent,
    boxShadow: "none",
    outline: "none",
  },
  "&.Mui-focusVisible": {
    background: "transparent",
    color: theme.nawy.colors.semantic.text.accent,
    boxShadow: "none",
  },
});
